import { createFileRoute } from '@tanstack/react-router'
import { TeamTrash } from '@components'

export const Route = createFileRoute('/team_/trash/')({
  component: () => <TeamTrash />,
})
